// Generated by CoffeeScript 2.4.1
(function() {
  // Libs
  var CoreManager, Error, ErrorCodes, LocalController, Promise, Weaver, WeaverError, _, enc,
    indexOf = [].indexOf;

  _ = require('lodash');

  Promise = require('bluebird');

  LocalController = require('./LocalController');

  Error = require('./Error');

  Weaver = require('./Weaver');

  WeaverError = require('./Error');

  ErrorCodes = require('./WeaverError');

  enc = encodeURIComponent;

  CoreManager = class CoreManager {
    constructor(CommControllerClass) {
      // calls and payload
      this.REQUEST = this.REQUEST.bind(this);
      this.CommControllerClass = CommControllerClass;
      this.reset();
    }

    reset() {
      this.defaultBranch = 'main';
      this.currentProject = void 0;
      this.currentBranch = void 0;
      this.currentModel = void 0;
      this.transactionMap = {}; // maps transaction id to transaction
      this.currentOpenResultSets = {}; // maps transaction id to array of open result set ids
      this.maxBatchSize = 500;
      return this.op = Promise.resolve();
    }

    async connect(endpoint, options) {
      var defaultOptions, e;
      this.options = options;
      defaultOptions = {
        rejectUnauthorized: true
      };
      this.options = this.options || defaultOptions;
      this.endpoint = endpoint;
      try {
        this.commController = new this.CommControllerClass(endpoint, this.options);
        return (await this.commController.connect());
      } catch (error) {
        e = error;
        console.warn('Waiting for 2 sec for weaver-server...');
        await Promise.delay(2000);
        return this.connect(endpoint);
      }
    }

    disconnect() {
      return this.enqueue(async() => {
        await this.commController.disconnect();
        return this.reset();
      });
    }

    local(routes) {
      this.commController = new LocalController(routes);
      return Promise.resolve();
    }

    getCommController() {
      return this.commController;
    }

    createStream() {
      return this.commController.createStream();
    }

    _resolveTarget(target) {
      if (this.currentProject != null) {
        // Fallback to currentProject if target not given
        target = target || this.currentProject.id();
      }
      return target;
    }

    _resolveBranch(branch, transaction) {
      var resolvedBranch;
      // Fallback to currentBranch if target not given
      resolvedBranch = this.defaultBranch;
      if (branch != null) {
        resolvedBranch = branch;
      } else if (transaction != null ? transaction.getBranch() : void 0) {
        resolvedBranch = transaction.getBranch();
      } else if (this.currentBranch != null) {
        resolvedBranch = this.currentBranch.id();
      }
      return resolvedBranch;
    }

    resetBranch() {
      return this.currentBranch = void 0;
    }

    _resolvePayload(type, payload, target, branch, transaction) {
      var ref;
      payload = payload || {};
      payload.type = type;
      if (payload.branch == null) {
        payload.branch = this._resolveBranch(branch, transaction);
      }
      if (payload.target == null) {
        payload.target = this._resolveTarget(target);
      }
      if (payload.authToken == null) {
        payload.authToken = (ref = this.currentUser) != null ? ref.authToken : void 0;
      }
      return payload;
    }

    async _executeDirectBatchOperations(allOperations, params = {}) {
      var e, ress, trx, trxOutsideScope;
      trx = params.transaction;
      trxOutsideScope = trx != null;
      ress = void 0;
      if (trx == null) {
        trx = (await Weaver.getInstance().startTransaction({
          ttlSeconds: params.ttlSeconds,
          branch: params.branch,
          project: params.project,
          lockTimeoutSeconds: params.lockTimeoutSeconds
        }));
        params.transactions = trx;
      }
      try {
        ress = (await Promise.mapSeries(_.chunk(allOperations, this.maxBatchSize), async(operations) => {
          return (await this.executeOperations(operations, params));
        }));
      } catch (error) {
        e = error;
        await trx.rollback();
        throw e;
      }
      if (!trxOutsideScope) {
        await trx.commit();
      }
      return ress;
    }

    async _executeBatchedOperations(allOperations, params = {}) {
      var branchUrlParam, res, trx, trxOutsideScope;
      trx = params.transaction;
      trxOutsideScope = trx != null;
      res = void 0;
      if (trx == null) {
        trx = (await Weaver.getInstance().startTransaction({
          ttlSeconds: params.ttl,
          branch: params.branch,
          project: params.project,
          lockTimeoutSeconds: params.lockTimeoutSeconds
        }));
      }
      branchUrlParam = '';
      if (params.branch != null) {
        // Careful, the parameter seperator is in here
        branchUrlParam = `branch=${encodeURIComponent(params.branch)}&`;
      }
      await this.POST("v2.projects", {
        method: "POST",
        path: `/meta/functions/start_staging?${branchUrlParam}transaction=${encodeURIComponent(trx.id())}`,
        applicationSecret: Weaver.getInstance().getApplicationSecret()
      });
      await Promise.mapSeries(_.chunk(allOperations, this.maxBatchSize), async(operations) => {
        return (await this.POST("v2.projects", {
          method: "POST",
          path: `/meta/functions/stage_writes?${branchUrlParam}transaction=${encodeURIComponent(trx.id())}`,
          applicationSecret: Weaver.getInstance().getApplicationSecret(),
          body: operations
        }));
      });
      res = (await this.POST("v2.projects", {
        method: "POST",
        path: `/meta/functions/perform_staged_writes?${branchUrlParam}transaction=${encodeURIComponent(trx.id())}` + `&commitMsg=${encodeURIComponent(params.commitMessage)}&squash=${params.squash || 'false'}`,
        applicationSecret: Weaver.getInstance().getApplicationSecret()
      }));
      if (!trxOutsideScope) {
        await trx.commit();
      }
      return res;
    }

    async executeOperations(operations, params = {}) {
      var payload, res, trx;
      if (operations.length > this.maxBatchSize) {
        if (params.strict || params.squash) {
          return (await this._executeBatchedOperations(operations, params));
        } else {
          return (await this._executeDirectBatchOperations(operations, params));
        }
      }
      trx = params.transaction;
      payload = {operations};
      if (trx != null) {
        payload.transaction = trx.id();
      }
      payload.applicationSecret = Weaver.getInstance().getApplicationSecret();
      payload.body = {
        commitMsg: params.commitMessage,
        squash: params.squash,
        userId: params.userId,
        timestamp: params.timestamp,
        lockTimeoutSeconds: params.lockTimeoutSeconds
      };
      res = void 0;
      res = (await this.POST('write', payload, params.project, params.branch, trx));
      if (res != null ? res.errored : void 0) {
        throw new Error(`The commit failed with these conflicts: ${JSON.stringify(res)}`);
      }
      return res;
    }

    enqueue(functionToEnqueue) {
      var capture;
      capture = async() => {
        try {
          await this.op;
        } catch (error) {}
        return functionToEnqueue();
      };
      return this.op = capture();
    }

    serverVersion() {
      return this.GET("application.version");
    }

    async connectorVersion() {
      var about;
      about = (await this.GET("v2", {
        method: "GET",
        path: "/about"
      }));
      return about.version;
    }

    serverChangelog() {
      return this.GET("server-changelog");
    }

    isSelfSignupEnabled() {
      return this.GET('users.signUpEnabled');
    }

    connectorChangelog() {
      return this.POST("v2", {
        method: "GET",
        path: "/changelog"
      });
    }

    listCommits(target, limit, offset) {
      return this.POST("v2.projects", {
        method: "GET",
        path: "/commits",
        parameters: {
          limit: limit,
          offset: offset
        }
      }, target);
    }

    shout(message) {
      return this.POST("socket.shout", {message});
    }

    async signInUsername(username, password) {
      var newToken;
      newToken = (await this.POST("user.signInUsername", {username, password}, "$SYSTEM"));
      return this._handleSignIn(newToken);
    }

    async signInEmail(email, password) {
      var newToken;
      newToken = (await this.POST('user.signInEmail', {email, password}, "$SYSTEM"));
      return this._handleSignIn(newToken);
    }

    // Sign the user in using an authToken
    async signInToken(authToken) {
      var newToken;
      newToken = (await this.POST("user.signInToken", {authToken}, "$SYSTEM"));
      return this._handleSignIn(newToken);
    }

    async refreshToken(authToken) {
      return (await this.POST("user.refreshToken", {
        authToken,
        applicationSecret: Weaver.getInstance().getApplicationSecret()
      }, "$SYSTEM"));
    }

    async _handleSignIn(authToken) {
      var serverUser;
      this.currentUser = Weaver.User.get(authToken);
      serverUser = (await this.POST("user.read", {}, "$SYSTEM"));
      this.currentUser.populateFromServer(serverUser);
      return this.currentUser;
    }

    async signOutCurrentUser() {
      await this.POST("user.signOut", {}, "$SYSTEM");
      this.currentUser = void 0;
    }

    // wiping functions
    wipeProjects(target) {
      return this.POST('projects.wipe', {}, target);
    }

    destroyProjects(target) {
      return this.POST('projects.destroy', {}, target);
    }

    wipeUsers(target) {
      return this.POST('users.wipe', {}, target);
    }

    wipeACL(target) {
      return this.POST("acl.wipe", {}, target);
    }

    // query functions
    async query(query) {
      var base, branch, name, ref, res, target, transaction;
      if (query._returnEmpty) {
        return Promise.resolve({
          nodes: []
        });
      } else {
        target = query.target;
        branch = query.branchId;
        transaction = query.transaction;
        if ((query._resultSetId != null) && !(ref = query._resultSetId, indexOf.call(((base = this.currentOpenResultSets)[name = transaction.id()] != null ? base[name] : base[name] = []), ref) >= 0)) {
          this.currentOpenResultSets[transaction.id()].push(query._resultSetId);
        }
        query = _.omit(query, ['model', 'context', 'target', '_cache', 'preferredConstructor', 'constructorFunction', 'branchId', 'transaction']);
        res = (await this.POST("query", {
          query,
          unparsed: true
        }, target, branch, transaction));
        if (typeof res !== 'object') {
          return JSON.parse(res);
        } else {
          throw WeaverError(ErrorCodes.OTHER_CAUSE, res);
        }
      }
    }

    async sparql(query) {
      var base, branch, name, ref, res, target, transaction;
      target = query.target;
      branch = query.branchId;
      transaction = query.transaction;
      if ((query._resultSetId != null) && !(ref = query._resultSetId, indexOf.call(((base = this.currentOpenResultSets)[name = transaction.id()] != null ? base[name] : base[name] = []), ref) >= 0)) {
        this.currentOpenResultSets[transaction.id()].push(query._resultSetId);
      }
      query = _.omit(query, ['branchId', 'transaction']);
      res = (await this.POST("query.sparql", {
        query,
        unparsed: true
      }, target, branch, transaction));
      if (typeof res !== 'object') {
        return JSON.parse(res);
      } else {
        throw WeaverError(ErrorCodes.OTHER_CAUSE, res);
      }
    }

    nativeQuery(query, target) {
      return this.POST("query.native", {query}, target);
    }

    releaseResultSet(transaction, resultSetId) {
      _.pull(this.currentOpenResultSets[transaction.id()], resultSetId);
      return this.POST("query.release", {
        transactionId: transaction.id(),
        resultSetId,
        target: transaction.getProject()
      });
    }

    async gitBlame(nodeId, transaction) {
      return (await this.POST("v2.projects", {
        method: "GET",
        path: `/branches/${enc(this._resolveBranch(void 0, transaction))}/blame?nodeId=${enc(nodeId)}`
      }));
    }

    async gitShow(commitId, transaction) {
      return (await this.POST("v2.projects", {
        method: "GET",
        path: `/branches/${enc(this._resolveBranch(void 0, transaction))}/show?commitId=${commitId}`
      }));
    }

    REQUEST(type, path, payload, target, branch, transaction) {
      payload = this._resolvePayload(type, payload, target, branch, transaction);
      switch (type) {
        case "GET":
          return this.commController.GET(path, payload);
        case "POST":
          return this.commController.POST(path, payload);
        case "STREAM":
          return this.commController.STREAM(path, payload);
      }
    }

    REQUEST_HTTP(path, payload, target) {
      return payload = this._resolvePayload(payload, target);
    }

    GET(path, payload, target) {
      return this.REQUEST("GET", path, payload, target);
    }

    POST(path, payload, target, branch, transaction) {
      return this.REQUEST("POST", path, payload, target, branch, transaction);
    }

    STREAM(path, payload, target) {
      return this.REQUEST("STREAM", path, payload, target);
    }

  };

  module.exports = CoreManager;

}).call(this);
